import React, {useState} from 'react'
import './Singleselect.css'

let splitedval = []

const Twitterfeed = ({selectedSocVal, placeholder, socialjs}) => {
    const [socialvalue, setSocialvalue] = useState("")
    const [social, setSocial] = useState(false)
    const [dealss, setDealss] = useState([])          // Arrays of Objects holding durrent deals {key: 1, dels: Tour}
    const [partvalue, setPartvalue] = useState("")
    const [test, setTest] = useState('')
    
    const handleSocialClick = (e, incoming) =>{
        let arrayindexLength = splitedval[splitedval.length - 1].length
        setTest(socialvalue + incoming.soc)
        setSocialvalue(socialvalue.substring(0,test.length - arrayindexLength) + incoming.soc)
        setSocial(!social)
        selectedSocVal(incoming.soc)
    }

    const handleValueChange = (e) =>{
        // if(Array.from(e.target.value)[0] === '@'){       // If the first character of a string equals @
        if(e.target.value.includes('@')){
            let screenval = e.target.value
            setTest(screenval)            
            splitedval = screenval.split('@')               // split the current value on the screen by @ into arrays
            setSocial(true)
            setSocialvalue(screenval)
            setPartvalue(splitedval[splitedval.length - 1])
        } 
        else if(e.target.value === ''){
            setSocial(false)
            setSocialvalue(e.target.value)
        }
    }
    
    var SocialLists = socialjs.filter((filteredItem) => {
        if (filteredItem.name.toLowerCase().includes(partvalue.toLowerCase())) {
          return filteredItem;
        }
    });

  // Onclick of element close button remove item from array list
  const handleClosedealItem = (e, incoming) =>{
    setDealss(dealss.filter((filteredeals)=>(filteredeals.key !== incoming.itemid)))
  }

  return (
    <div className='sing-selectt-container'>
        <textarea placeholder={placeholder} value={socialvalue}  onChange={handleValueChange} id="bnw-dropdown-box" />

            {social && <div className='bnw-regionn-drpdwn'>{SocialLists.sort((a, b) => a.name > b.name ? 1 : -1).map((item, key) => (
                <span onClick={e => handleSocialClick(e, {soc: item.name})} key={key}>{item.name}</span>
            ))}
            </div>}
    </div>
  )
}

export default Twitterfeed